<template>
  <div class="flex flex-col pt-[1%] px-[2%] gap-4">
    <div v-if="despacho.estado_despacho == 'Presentado Pendiente de pago'">
      <button
        id="deleteAll"
        @click="getComprobante()"
        class="btn-principal ml-auto"
      >
        Buscar Comprobante TGR
        <fas icon="share"></fas>
      </button>
    </div>

    <form-pago
      v-if="agregarPago && !editar && pagos && proveedores"
      :postPago="postPago"
      :pagos="pagos"
      :proveedores="proveedores"
      :cancelar="cancelar"
    >
    </form-pago>

    <form-pago-editar
      v-if="agregarPago && editar && pagoEditar && pagos && proveedores"
      :postPago="updatePago"
      :pagos="pagos"
      :pagoEditar="pagoEditar"
      :proveedores="proveedores"
      :cancelar="cancelar"
      :files_old="files_old"
    >
      <template slot="cancelar">
        <button class="btn-secundario" @click="cancelar()" type="button">
          Cancelar
        </button>
      </template>
    </form-pago-editar>

    <div v-if="montos" class="grid grid-cols-3 w-full mx-auto gap-4">
      <div class="text-center">
        <h5>MONTO ENTRANTE</h5>
        <p class="font-bold">{{ montos.monto_entrante }}</p>
      </div>

      <div class="text-center">
        <h5>MONTO SALIENTE</h5>
        <p class="font-bold">{{ montos.monto_saliente }}</p>
      </div>

      <div class="text-center">
        <h5>BALANCE</h5>
        <p class="font-bold">
          {{
            parseInt(montos.monto_entrante) - parseInt(montos.monto_saliente)
          }}
        </p>
      </div>
    </div>

    <b-table
      striped
      hover
      :items="pagosTabla"
      :fields="fields"
      show-empty
      responsive
    >
      <template #empty>
        <h4>No hay pagos disponibles</h4>
      </template>
      <template #cell(created_at)="row">
        <p>{{ moment(row.item.created_at).format("DD-MM-YYYY HH:mm") }}</p>
      </template>
      <template #cell(fecha_pago)="row">
        <p v-if="row.item.fecha_pago === null">{{}}</p>
        <p v-else>{{ moment(row.item.fecha_pago).format("DD-MM-YYYY") }}</p>
      </template>
      <template #cell(proveedor)="row">
        <p>{{}}</p>
      </template>
      <template #cell(monto)="row">
        <p>
          {{
            new Intl.NumberFormat("es-CL", {
              currency: "CLP",
              style: "currency",
            }).format(row.item.monto)
          }}
        </p>
      </template>
      <template #cell(documentos)="row">
        <button
          class="btn-archivo-tabla"
          :title="pago.ruta"
          v-for="(pago, index) in row.item.archivos"
          :key="index"
          style="width: 20px"
          @click="downloadPago(pago.id)"
        >
          <inline-svg
            v-if="pago.ruta.split('.').at(-1) == 'pdf'"
            src="../../assets/images/archivo-pdf.svg"
          />
          <inline-svg
            v-if="
              pago.ruta.split('.').at(-1) == 'png' ||
              pago.ruta.split('.').at(-1) == 'jpg' ||
              pago.ruta.split('.').at(-1) == 'jpeg'
            "
            src="../../assets/images/archivo-png.svg"
          />
        </button>
      </template>
      <template #cell(documento_name)="row">
        <p :key="index" v-for="(pago, index) in row.item.archivos">
          {{ pago.ruta.split("/")[1] }}
        </p>
      </template>
      <template #cell(acciones)="row">
        <!-- <button  @click="editarPago(row.item)" class="btn-extra-secundario btn-small mr-1">
                    Editar <inline-svg  class="icono-titulo" src="../../assets/images/Editar.svg" title="My Image"/>
                </button> -->

        <div
          v-if="
            row.item.id_gasto &&
            !(
              row.item.tipo_documento_contable ||
              row.item.nro_documento ||
              row.item.fecha_pago ||
              row.item.archivos.length != 0
            )
          "
        >
          <button
            @click="editarPago(row.item)"
            v-if="canManage()"
            class="btn-extra-secundario btn-small mr-2"
          >
            Completar
            <fas :icon="['fas', 'edit']" />
          </button>
          <button
            @click="eliminarPago(row.item.id, row.item.tipo ? row.item.tipo.nombre : '')"
            v-if="canManage()"
            class="btn-principal"
          >
            Eliminar
            <inline-svg
              class="icono-titulo"
              src="../../assets/images/basura.svg"
              title="My Image"
            />
          </button>
        </div>
        <div v-else>
          <button
            @click="eliminarPago(row.item.id, row.item.tipo ? row.item.tipo.nombre : '')"
            v-if="canManage()"
            class="btn-principal"
          >
            Eliminar
            <inline-svg
              class="icono-titulo"
              src="../../assets/images/basura.svg"
              title="My Image"
            />
          </button>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import axios from "axios";
import FormPago from "../../formulario/FormPago.vue";
import FormPagoEditar from "../../formulario/FormPagoEditar.vue";
import moment from "moment";
export default {
  components: { FormPago, FormPagoEditar },
  props: {
    despacho: Object,
    agregarPago: Boolean,
    pagosTabla: Array,
    montos: Object,

    canManage: {
      type: Function,
      default: () => {
        return true;
      },
    },

    postPago: Function,
    updatePago: Function,
    eliminarPago: Function,
    getComprobante: Function,
  },
  data() {
    return {
      fields: [
        { key: "tipo.nombre", label: "Tipo" },
        { key: "tipo_documento_contable", label: "Documento Contable" },
        { key: "proveedor.nombre", label: "Proveedor" },
        { key: "monto", label: "Monto" },
        { key: "fecha_pago", label: "Fecha Documento" },
        { key: "usuario.name", label: "Usuario" },
        { key: "documentos", label: "Pagos" },
        { key: "documento_name", label: "Nombre Documento" },
        { key: "acciones", label: "Acciones" },
      ],

      editar: false,

      pagoEditar: null,

      files_old: [],
      pagos: null,
      proveedores: null,
    };
  },
  mounted() {
    if (!this.agregarPago) this.fields.pop();
    else this.getTiposPagos();
    this.getProveedores();
  },
  methods: {
    editarPago(pago) {
      this.pagoEditar = pago;

      this.files_old = [];
      this.pagoEditar.archivos.forEach((el) => {
        this.files_old.push({ id: el.id, name: el.ruta });
      });
      this.editar = true;
    },
    cancelar() {
      this.editar = false;
    },
    async downloadPago(id) {
      window.open(
        process.env.VUE_APP_API_URL +
          `/api/admin/archivo/${id}/descargar/despacho`
      );
    },
    async getTiposPagos() {
      await axios
        .get(`api/admin/pagos/tipos-pagos/${this.despacho.id}`)
        .then((res) => {
          this.pagos = {
            tipos_pagos: res.data.data.tipo_pagos,
            tipo_documento_contable: res.data.data.tipo_documento_contable,
          };
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getProveedores() {
      await axios
        .get("/api/admin/proveedores/pagos")
        .then((resp) => {
          this.proveedores = resp.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style></style>
